import { apiManufactureFormulasChangeStatus } from "api/manufactureFormulaApi";
import Switch from "pages/business/Subscription/Switch";
import { useDispatch } from "react-redux";
import { useAppSelector } from "store/store";

type Props = {
  item: any;
};

const ManufactureFormulaSwitch = ({ item }: Props) => {
  const dispatch = useDispatch();
  const store = useAppSelector((x) => x);
  const token = store.businessReducer.business.token;

  return (
    <div className="flex items-center justify-center">
      <Switch
        active={item?.active}
        size={2}
        onChange={() => {
          //@ts-ignore
          dispatch(apiManufactureFormulasChangeStatus(item.id, token));
        }}
      />
    </div>
  );
};

export default ManufactureFormulaSwitch;
